import { useState } from 'react';

interface FAQ {
  q: string;
  a: string;
}

interface FAQSectionProps {
  faqs: FAQ[];
  eyebrow?: string;
  heading?: string;
}

export default function FAQSection({
  faqs,
  eyebrow = 'Common Questions',
  heading = 'Frequently Asked Questions',
}: FAQSectionProps) {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="bg-cream py-24">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="grid md:grid-cols-5 gap-16">
          <div className="md:col-span-2">
            <span className="text-xs tracking-[0.2em] uppercase text-stone font-sans">{eyebrow}</span>
            <h2 className="font-display text-4xl md:text-5xl font-light text-charcoal mt-4 leading-tight">
              {heading}
            </h2>
            <p className="text-charcoal/50 text-sm leading-relaxed font-sans mt-6 max-w-xs">
              Everything you need to know about working with Lisa Merkle Design — from process to pricing to timelines.
            </p>
          </div>

          <div className="md:col-span-3">
            {faqs.map((faq, i) => (
              <div key={i} className="border-b border-charcoal/10">
                <button
                  onClick={() => setOpen(open === i ? null : i)}
                  className="w-full flex items-start justify-between gap-6 py-6 text-left cursor-pointer group"
                >
                  <span className={`text-sm md:text-base font-sans font-medium leading-snug transition-colors ${open === i ? 'text-stone-dark' : 'text-charcoal group-hover:text-stone-dark'}`}>
                    {faq.q}
                  </span>
                  <span className={`flex-shrink-0 w-5 h-5 flex items-center justify-center transition-transform mt-0.5 ${open === i ? 'rotate-45' : ''}`}>
                    <i className="ri-add-line text-charcoal/40 text-lg" />
                  </span>
                </button>
                {open === i && (
                  <div className="pb-6">
                    <p className="text-charcoal/60 text-sm leading-relaxed font-sans">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
